import { getMobileOperatingSystem } from "../utils/utils";
if(getMobileOperatingSystem().toLowerCase() === 'ios') {    
    document.querySelector("[name=viewport]")
    .setAttribute("content","width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover");
}